// A step of the task's graph opened in a dialog (D89): its runs and Move back.
import { plural } from "../../../helpers";

const p = plural("en");

export default {
  hint: "Select a step to see what it was sent and what it answered.",
  ran: (n: number) => p(n, { one: "ran once", other: "ran # times" }),
  currentStep: "the task is on it",
  notVisited: "Not visited yet",
  notVisitedBody: "The task has not reached this step. Its runs show here once it does.",
  runLabel: (n: number, of: number) => (of === 1 ? "Run" : `Run ${n} of ${of}`),
  started: (time: string) => `Started ${time}`,
  tokens: (n: string) => `${n} tokens`,
  noConversation: "Nothing was written to the conversation for this run.",
  conversationHidden: (reason: string) => `The prompt and answer are in the encrypted conversation. ${reason}.`,
  asked: "Asked",
  answered: "Your answer",
  noAnswer: "Not answered yet",
  ended: (result: string) => `Ended the task: ${result}`,
  moveBack: "Move back to this step",
  moveBackConfirm: (name: string) => `Move back to ${name}?`,
  moveBackBody:
    "The task continues from this step. This run and the steps after it stop counting towards their visit limits; their history, costs and conversation stay.",
  moveBackNoteLabel: "Why? (optional, a note for the step)",
  moveBackNotePlaceholder: "For example: the plan missed the retry path; cover it this time",
  moveBackGo: "Move back",
  movedBack: (name: string) => `Moved back to ${name}`,
  moveBackWhenFinished: "Move back is available once the task has finished. Cancel it first to move back now.",
};
